module.exports = function() {
  return new Worker(__webpack_public_path__ + "2ef2a3c2ac04d46b210c.worker.js");
};